var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "relative border border-primary-500 py-1 pl-3 pr-8" },
    [
      _vm._v(" " + _vm._s(_vm.name) + " "),
      _c("button", {
        staticClass:
          "cursor-pointer w-5 h-5 text-center absolute right-0 mdi mdi-close mr-1 hover:bg-gray-200",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.$emit("remove")
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }